import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
    static values = { modalId: String }

    // Hook this to turbo:submit-end on the form
    closeOnSuccess(event) {
        if (!event.detail?.success) return

        const modalEl =
            this.element.closest(".modal") ||
            (this.hasModalIdValue ? document.getElementById(this.modalIdValue) : null) ||
            document.getElementById(this.modalIdValue || "")

        if (!modalEl) return

        const instance = bootstrap.Modal.getOrCreateInstance(modalEl)

        modalEl.addEventListener("hidden.bs.modal", () => {
            document.querySelectorAll(".modal-backdrop.show").forEach(node => node.remove())
            document.body.classList.remove("modal-open")
            document.body.style.removeProperty("padding-right")
        }, { once: true })

        instance.hide()
    }

    // Close when user clicks Cancel/X
    close(event) {
        event?.preventDefault()
        // We mount the modal inside a turbo-frame; removing the frame closes it
        this.element.remove()
    }

    navigate(event) {
        event.preventDefault()
        const href = event.currentTarget.getAttribute("href")
        this._dismiss()
        if (href) Turbo.visit(href)
    }

    toFrame(event) {
        event.preventDefault()

        const link    = event.currentTarget
        const href    = link.getAttribute("href")
        const frameId = link.dataset.turboFrame || link.getAttribute("data-turbo-frame")
        if (!href || !frameId) return

        // Find the real Bootstrap modal element
        const modalEl = link.closest(".modal")
        const instance = modalEl ? bootstrap.Modal.getOrCreateInstance(modalEl) : null

        const performFrameVisit = () => {
            Turbo.visit(href, { frame: frameId })
        }

        if (instance && modalEl) {
            const onHidden = () => {
                modalEl.removeEventListener("hidden.bs.modal", onHidden)
                performFrameVisit()
            }
            modalEl.addEventListener("hidden.bs.modal", onHidden)
            instance.hide()         // let Bootstrap restore scroll, then navigate
        } else {
            // Fallback if no modal instance found
            performFrameVisit()
        }
    }

    _dismiss() {
        // If using a real Bootstrap modal element, hide it first
        const id = this.modalIdValue
        const el = id ? document.getElementById(id) : null
        if (el) {
            bootstrap.Modal.getOrCreateInstance(el).hide()
        }
        // Clean up Turbo-rendered modal wrapper + Bootstrap leftovers
        document.querySelectorAll(".modal-backdrop.show").forEach(node => node.remove())
        document.body.classList.remove("modal-open")
        document.body.style.removeProperty("padding-right")
        // If your modal lives in a turbo-frame, removing the frame closes it
        this.element?.remove()
    }

}